const DAY_MS = 24 * 60 * 60 * 1000;

export function defaultForensicsDateInputs(): { sinceDate: string; untilDate: string } {
  const until = new Date();
  const since = new Date(Date.now() - 7 * DAY_MS);
  return {
    sinceDate: toDateInputValue(since),
    untilDate: toDateInputValue(until),
  };
}

export function toDateInputValue(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Local calendar day start → ISO for API `since`. */
export function dateInputToSinceIso(dateStr: string): string | undefined {
  const trimmed = dateStr.trim();
  if (!trimmed) return undefined;
  const d = new Date(`${trimmed}T00:00:00`);
  if (!Number.isFinite(d.getTime())) return undefined;
  return d.toISOString();
}

/** Local calendar day end → ISO for API `until`. */
export function dateInputToUntilIso(dateStr: string): string | undefined {
  const trimmed = dateStr.trim();
  if (!trimmed) return undefined;
  const d = new Date(`${trimmed}T23:59:59.999`);
  if (!Number.isFinite(d.getTime())) return undefined;
  return d.toISOString();
}
